import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountryCellViewComponent } from './country-cell-view.component';
import { CustomTooltipModule } from '@purespectrum1/ui';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CountryViewableCellContentDirective } from './directives/country-viewable-cell-content.directive';
import { CountryHoverableCellContentDirective } from './directives/country-hoverable-cell-content.directive';

@NgModule({
  declarations: [
    CountryCellViewComponent,
    CountryViewableCellContentDirective,
    CountryHoverableCellContentDirective,
  ],
  imports: [CommonModule, CustomTooltipModule, DragDropModule],
  exports: [
    CountryCellViewComponent,
    CountryViewableCellContentDirective,
    CountryHoverableCellContentDirective,
  ],
})
export class CountryCellViewModule {}
